import {AppState} from './types'

// account selectors
export const selectUserRole = (state: AppState): number | null => state.account.roleId
export const selectAccountAccess = (state: AppState) => ({
  hasAccess: state.account.hasAccess,
  hasServerError: state.account.hasServerError,
  isLoadedPermission: state.account.isLoadedPermission,
})
export const selectHeaderData = (state: AppState) => ({
  roleId: state.account.roleId,
  userName: state.account.name,
  handleLogout: state.account.handleLogout,
  language: state.account.language,
  hasAccess: state.account.hasAccess,
})

// stations selectors
export const selectStations = (state: AppState) => ({
  spp: state.stations.spp,
  wpp: state.stations.wpp,
})

// charts selectors
export const selectChartsData = (state: AppState) => ({
  cumulativeProductionBudget: state.charts.cumulativeProductionBudget,
  productionBudget: state.charts.productionBudget,
  averageDailyInsolation: state.charts.averageDailyInsolation,
  windResource: state.charts.windResource,
  energyAvailability: state.charts.energyAvailability,
  dateRange: state.charts.dateRange,
  isLoading: state.charts.isLoading,
  isLoaded: state.charts.isLoaded,
})

// charts live data selectors
export const selectChartsLiveData = (state: AppState) => ({
  nameValues: state.chartsLiveData.nameValues,
  windSpeedAndPower: state.chartsLiveData.windSpeedAndPower,
  insolationAndOutput: state.chartsLiveData.insolationAndOutput,
  isLoading: state.chartsLiveData.isLoading,
  isLoaded: state.chartsLiveData.isLoaded,
})

// business plan selectors
export const selectBusinessPlanData = (state: AppState) => state.businessPlan.businessPlanData
export const selectBusinessPlanLoading = (state: AppState) => ({
  isLoadingData: state.businessPlan.isLoading,
  isLoaded: state.businessPlan.isLoaded,
  isError: state.businessPlan.isError,
})

// shift selectors
export const selectShiftStatus = (state: AppState) => ({
  isLoading: state.shift.status.isLoading,
  isLoaded: state.shift.status.isLoaded,
  status: state.shift.status.status,
  canTransferShiftForcedReassignment: state.shift.status.canTransferShiftForcedReassignment,
  plantId: state.shift.status.plantId,
})
